import React from 'react'
import SignatureCanvas from 'react-signature-canvas'
import Modal from '../../shared/Modal'
import Button from '../../shared/Button'
import { inspectedSignatureApprovalTypes } from '../../store/inspection/reducers'

class InspectedSignature extends React.Component {
    state = {
        approvalResult: null,
        errors: null,
    }
    sigCanvas = {}
    clearSignature = () => {
        this.sigCanvas.clear()
        this.setState({ approvalResult: null })
    }
    componentDidMount() {
        setTimeout(
            function () {
                if (this.props.inspectedSignature && this.props.inspectedSignature.signature) {
                    this.sigCanvas.fromDataURL(this.props.inspectedSignature.signature)
                }
            }.bind(this),
            500
        )
        this.setState({
            approvalResult: this.props.inspectedSignature ? this.props.inspectedSignature.approvalResult : null,
        })
    }

    onHandleApprovalResult = (result) => {
        this.setState({
            approvalResult: result,
            errors: null,
        })
    }

    setErrorMessage = (errorKey, errorMessage) => {
        this.setState((prevState) => {
            return {
                errors: {
                    ...prevState.errors,
                    [errorKey]: errorMessage,
                },
            }
        })
    }

    resetErrors = () => {
        this.setState({
            errors: {},
        })
    }

    onHandleSaveSignature = () => {
        this.resetErrors()
        let hasError = false
        if (!this.state.approvalResult) {
            this.setErrorMessage('approvalResult', '¡Debe de indicar su conformidad!')
            hasError = true
        }

        const signature = this.sigCanvas.getTrimmedCanvas().toDataURL('image/png')

        if (this.sigCanvas.isEmpty()) {
            this.setErrorMessage('signature', '¡Debe de firmar!')
            hasError = true
        }
        if (hasError) return
        this.props.saveSignature(signature, this.state.approvalResult)
    }

    render() {
        const { close } = this.props

        //Para móvil
        let widthCanvan = 795
        if (window.innerWidth < 480) {
            widthCanvan = 'auto'
        }

        return (
            <div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    onClose={this.props.close}
                    title="Firma del colaborador"
                    footer={
                        <React.Fragment>
                            <Button type="submit" onClick={this.onHandleSaveSignature}>
                                He terminado
                            </Button>
                            <Button type="submit" className={'btnCrear'} onClick={this.clearSignature}>
                                Repetir firma
                            </Button>
                            <Button type="submit" onClick={close}>
                                Cancelar
                            </Button>
                        </React.Fragment>
                    }
                >
                    <div>
                        <form autoComplete="off">
                            <ul className="form__body">
                                <li className="form__line">
                                    <div style={{ border: '1px solid' }}>
                                        {this.state.errors && this.state.errors.signature && <span className="form__error"> {this.state.errors.signature}</span>}

                                        <SignatureCanvas
                                            penColor="blue"
                                            clearOnResize={
                                                false //maxWidth={4} //minWidth={1}
                                            }
                                            ref={(ref) => {
                                                this.sigCanvas = ref
                                            }}
                                            canvasProps={{ width: widthCanvan, height: 280, className: 'signCanvas' }}
                                        />
                                    </div>
                                </li>
                                <li className="form__line">
                                    <div className="form__group">
                                        <label className="form__label">
                                            Indique su conformidad:
                                            {this.state.errors && this.state.errors.approvalResult && <span className="form__error"> {this.state.errors.approvalResult}</span>}
                                        </label>

                                        <ul component="nav" className="buttons__panel--column">
                                            <li
                                                className={
                                                    this.state.approvalResult === inspectedSignatureApprovalTypes.AGREE
                                                        ? 'link__SignatureWorkOrder--active'
                                                        : 'link__SignatureWorkOrder'
                                                }
                                                onClick={() => this.onHandleApprovalResult(inspectedSignatureApprovalTypes.AGREE)}
                                            >
                                                Conforme
                                            </li>
                                            <li
                                                className={
                                                    this.state.approvalResult === inspectedSignatureApprovalTypes.DISAGREE
                                                        ? 'link__SignatureWorkOrder--active'
                                                        : 'link__SignatureWorkOrder'
                                                }
                                                onClick={() => this.onHandleApprovalResult(inspectedSignatureApprovalTypes.DISAGREE)}
                                            >
                                                No Conforme
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </form>
                    </div>
                </Modal>
            </div>
        )
    }
}

// CustomerSignature.propTypes = {
//     classes: PropTypes.object.isRequired
// }

export default InspectedSignature
